import { Typography } from '@mui/material';
import ContactUsLead from '../ContactUsLead';
import {
  BoxContactUsLeadBannerContainer,
  titleStyles,
  subtitleStyles,
  ContentContainerBox,
  ImageContainerBoxMobile,
  SendImageStylesMobile,
  SendImageStylesDesktop,
} from './useStyles';
import { RESOURCES } from '~/resources/resources';
import SendImage from '~/assets/images/jsx/sendImage';
import { useIsMobile } from '~/hooks/useIsMobile';
import { FC } from 'react';
import ContactUsSuccessPage from '../ContactUsSuccessPage';
import { useLeadActions } from '~/hooks/useLeadActions';

interface ContactUsLeadBannerProps {
  fullWidthMobile?: boolean;
}

const ContactUsLeadBanner: FC<ContactUsLeadBannerProps> = ({
  fullWidthMobile = true,
}) => {
  const isMobile = useIsMobile();
  const { createLeadFinished } = useLeadActions();

  return (
    <BoxContactUsLeadBannerContainer
      createLeadFinished={!!createLeadFinished}
      sx={!fullWidthMobile ? { margin: 0, marginBottom: '16px' } : undefined}
    >
      {createLeadFinished ? (
        <ContactUsSuccessPage isFullHeight />
      ) : (
        <>
          <ContentContainerBox>
            <Typography
              fontFamily="fontFamily"
              fontWeight="800"
              sx={titleStyles}
            >
              {RESOURCES.CONTACT_US_LEAD_BANNER_TITLE}
            </Typography>

            <Typography sx={subtitleStyles}>
              {RESOURCES.CONTACT_US_LEAD_BANNER_SUBTITLE}
            </Typography>
            {!isMobile && <SendImage style={SendImageStylesDesktop} />}
          </ContentContainerBox>

          <ContactUsLead />
          <ImageContainerBoxMobile>
            <SendImage style={SendImageStylesMobile} />
          </ImageContainerBoxMobile>
        </>
      )}
    </BoxContactUsLeadBannerContainer>
  );
};

export default ContactUsLeadBanner;
